import React from 'react';
import './Carousel.css';

const PACKAGES = [
  {
    tier: "Basic",
    tagline: "Perfect for intimate sessions and quick portraits",
    frequency: "per event",
    colorClass: "tier-basic",
    cta: "Book Basic",
    features: [
      "Traditional photo & video ",
      "Album(customizable)",
      "Photo backups",
      "Pendrive",
    ],
  },
  {
    tier: "Intermediate",
    tagline: "Balanced coverage for celebrations and ceremonies",
    frequency: "per event",
    colorClass: "tier-intermediate",
    cta: "Reserve Intermediate",
    features: [
      "Traditional photo & video ",
      "Candid photo & video ",
      "Album(customizable)",
      "Photo backups",
      "Pendrive",
      "Frame free",
    ],
  },
  {
    tier: "Advanced",
    tagline: "Full-day experience with cinematic storytelling",
    frequency: "per event",
    colorClass: "tier-advanced",
    cta: "Upgrade to Advanced",
    features: [
      "Traditional photo & video ",
      "Candid photo & video",
      "Post Wedding Shoot",
      "Drone coverage",
      "Album - 36 x 12",
      "Photo backups",
      "Pendrive",
      "Frame free",
      "Gifts",
    ],
  },
  {
    tier: "Custom",
    tagline: "Design every detail of your dream photography experience",
    price: "On Request",
    frequency: "tailored",
    colorClass: "tier-custom",
    featured: true,
    cta: "Design Your Custom Set",
    features: [
      "Customize your own package",
      /*"Customize your album",
      "Customize your gifts",
      "Traditional photo & video ",
      "Candid photo & video",
      "Additional photographer",
      "Additional videographer",
      "Drone coverage",
      "Pendrive and Photo backups",
      "Event-based selection (Haldi / Mehendi / Reception / Wedding)",
       */     
    ],
  },
];

// Reusable Checkmark Icon
const CheckIcon = () => (
  <svg className="check-icon" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 14.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
  </svg>
);

const Carousel = () => {
  return (
    <div className="carousel-wrapper">
      <main className="carousel-main">
        {/* ============================================== */}
        {/* 2. Featured Work Showcase (packages only) */}
        {/* ============================================== */}
        <section className="products-section">
          <h2 className="products-title">Photography Collections</h2>

          <div className="products-grid">
            {PACKAGES.map((pkg, index) => (
              <div 
                key={`${pkg.tier}-${index}`}
                className={`product-card package-card ${pkg.colorClass} ${pkg.featured ? 'featured-card' : ''}`}
              >
                <div className="package-header">
                  <span className="package-tier">{pkg.tier}</span>
                  <p className="package-tagline">{pkg.tagline}</p>
                </div>

               
                
                <ul className="product-features">
                  {pkg.features.map((feature, fIndex) => (
                    <li key={fIndex} className="feature-item">
                      <CheckIcon /> <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="product-footer">
                  <button className={`product-button ${pkg.featured ? 'featured-button' : ''}`}>
                    {pkg.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

      </main>
    </div>
  );
};

export default Carousel;
